import React, { useCallback } from 'react';
import { NewBuilding } from '@search/filter-enums/enums/NewBuilding';
import { NewBuildingFilter } from '../../../../../filters/models/Filter';
import { SlimSelect } from '../../../../../common/components/SlimSelect/SlimSelect';

interface IProps {
    filter: NewBuildingFilter;
    onChange: (filter: NewBuildingFilter) => void;
}

const SELECT_OPTIONS = [
    {
        label: 'Во вторичке',
        value: NewBuilding.SECOND.toString()
    }, {
        label: 'В новостройке',
        value: NewBuilding.NEW.toString()
    }, {
        label: 'Во вторичке или новостройке',
        value: NewBuilding.UNKNOWN.toString()
    }
];

export const DesktopNewBuildingTypeFilterView: React.FC<IProps> = ({
    filter,
    onChange
}) => {
    const value = (filter.newBuilding.length === 2 || filter.newBuilding.length === 0) ?
        NewBuilding.UNKNOWN.toString() :
        filter.newBuilding[0].toString();

    const handleChange = useCallback(
        (val: string) => {
            const parsedValue = parseInt(val, 10) as NewBuilding;

            if (parsedValue === NewBuilding.UNKNOWN) {
                onChange(new NewBuildingFilter([
                    NewBuilding.NEW,
                    NewBuilding.SECOND
                ]));

                return;
            }
            onChange(new NewBuildingFilter([ parsedValue ]));
        },
        [ onChange ]
    );

    return (
        <SlimSelect
            dataTest='newBuilding'
            size='s'
            placeholder='Во вторичке или новостройке'
            options={SELECT_OPTIONS}
            value={value}
            onChange={handleChange}
            adaptiveHeight={false}
            adaptivePlacement={false}
        />
    );
};
